<template lang="html">
  <v-app>
    <div>
      <vue-headful title="슥삭" description="포스터 조회" />
      <Navbar></Navbar>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm2>
            <Tabbar
              :ismobile="ismobile"
              :pagename="pagename"
              :drawer="drawer"
              :userinfo="userinfo"
            ></Tabbar>
          </v-flex>
          <v-flex
            :class="isMobile ? 'mx-auto mt-5 xs12' : 'mx-auto mt-5 xs12 sm10'"
          >
            <v-container fluid class="pl-10 pr-5">
              <v-row>
                <span class="col-12 rem-2 mt-5 text-left m_title"
                  >1. 포스터 분야 선택</span
                >
                <span class="col-12 rem-1 pt-0 text-left m_subtitle"
                  >포스터의 분야를 입력해주세요</span
                >
              </v-row>
              <v-row>
                <v-btn
                  :class="
                    posterCategoryIdx == 0
                      ? 'mt-3 mr-2 px-10 py-5 bg-main-dark-opac-15 text-main'
                      : 'mt-3 mr-2 px-10 py-5 text-grey-2 border-grey-3'
                  "
                  outlined
                  v-on:click="posterCategoryIdx = 0"
                  disabled
                  >공모전</v-btn
                >
                <v-btn
                  :class="
                    posterCategoryIdx == 1
                      ? 'mt-3 mx-2 px-10 py-5 bg-main-dark-opac-15 text-main'
                      : 'mt-3 mx-2 px-10 py-5 text-grey-2 border-grey-3'
                  "
                  outlined
                  v-on:click="posterCategoryIdx = 1"
                  disabled
                  >대외활동</v-btn
                >
                <!--
                                <v-btn :class="posterCategoryIdx == 2 ? 'mt-3 mx-2 px-10 py-5 bg-main-dark-opac-15 text-main': 'mt-3 mx-2 px-10 py-5 text-grey-2 border-grey-3'" outlined v-on:click="posterCategoryIdx = 2" disabled>동아리</v-btn>
                                -->
                <v-btn
                  :class="
                    posterCategoryIdx == 4
                      ? 'mt-3 mx-2 px-10 py-5 bg-main-dark-opac-15 text-main'
                      : 'mt-3 mx-2 px-10 py-5 text-grey-2 border-grey-3'
                  "
                  outlined
                  v-on:click="posterCategoryIdx = 4"
                  disabled
                  >인턴</v-btn
                >
                <v-btn
                  :class="
                    posterCategoryIdx == 9
                      ? 'mt-3 mx-2 px-10 py-5 bg-main-dark-opac-15 text-main'
                      : 'mt-3 mx-2 px-10 py-5 text-grey-2 border-grey-3'
                  "
                  outlined
                  v-on:click="posterCategoryIdx = 9"
                  disabled
                  >신입</v-btn
                >
                <v-btn
                  :class="
                    posterCategoryIdx == 7
                      ? 'mt-3 mx-2 px-10 py-5 bg-main-dark-opac-15 text-main'
                      : 'mt-3 mx-2 px-10 py-5 text-grey-2 border-grey-3'
                  "
                  outlined
                  v-on:click="posterCategoryIdx = 7"
                  disabled
                  >교육/강연</v-btn
                >
                <v-btn
                  :class="
                    posterCategoryIdx == 5
                      ? 'mt-3 mx-2 px-10 py-5 bg-main-dark-opac-15 text-main'
                      : 'mt-3 mx-2 px-10 py-5 text-grey-2 border-grey-3'
                  "
                  outlined
                  v-on:click="posterCategoryIdx = 5"
                  disabled
                  >기타</v-btn
                >
              </v-row>
              <v-row v-if="posterCategoryIdx == null" style="height: 1200px">
              </v-row>

              <div v-if="posterCategoryIdx != null">
                <v-row class="mt-5">
                  <span class="col-12 rem-2 mt-5 text-left m_title"
                    >2. 포스터 정보</span
                  >
                  <span class="col-12 rem-1 pt-0 text-left m_subtitle"
                    >포스터의 제목, 모집일, 홍보기간 등 기본 정보를
                    입력해주세요</span
                  >

                  <div
                    class="horizon-scroll col-md-4 col-sm-12 col-12 text-center mt-4"
                  >
                    <v-row v-if="reUpload == false">
                      <v-col cols="12" class="text-center">
                        <img :src="photoUrl" width="285" height="400" />
                      </v-col>
                      <v-btn
                        class="mt-2 mx-auto bg-main-dark text-white"
                        :width="285"
                        outlined
                        v-on:click="reUpload = true"
                        >다른 사진으로 재등록하기</v-btn
                      >
                    </v-row>
                    <v-row v-else>
                      <croppa
                        class="mx-auto"
                        v-model="croppa"
                        :width="285"
                        :height="400"
                        :outputWidth="570"
                        :outputHeigh="800"
                        :quality="6"
                        :file-size-limit="2048 * 4092"
                        :prevent-white-space="true"
                        accept=".jpg,.jpeg,.png"
                        :placeholder="'이미지를 등록해주세요'"
                        @file-choose="alert('file choose')"
                        @file-size-exceed="alert('file size exceeds')"
                        @file-type-mismatch="alert('file type mismatches')"
                        @new-image="alert('new image attatched')"
                        @image-remove="alert('image removed')"
                      >
                      </croppa>

                      <v-btn
                        class="mt-2 mx-auto bg-main-dark text-white"
                        :width="285"
                        :height="50"
                        v-on:click="upload()"
                        ><span class="rem-1"
                          >현재 사진으로 재등록<br /><span class="rem-0_8"
                            >(800x1120 권장)</span
                          ></span
                        ></v-btn
                      >
                      <v-btn
                        class="mt-2 mx-auto bg-main-dark-opac-15 text-main"
                        :width="285"
                        outlined
                        v-on:click="reUpload = false"
                        >취소</v-btn
                      >
                    </v-row>
                  </div>
                  <div class="col-md-8 col-sm-12 col-12 mt-4">
                    <!-- <v-text-field label="포스터 제목" outlined hint="제목을 입력해주세요." class="mt-2" v-model="posterName" block></v-text-field> -->
                    <v-text-field
                      :label="
                        posterCategoryIdx == 4 || posterCategoryIdx == 9
                          ? '직무'
                          : '포스터 제목'
                      "
                      :placeholder="
                        posterCategoryIdx == 4 || posterCategoryIdx == 9
                          ? '직무를 입력해주세요.'
                          : '제목을 입력해주세요.'
                      "
                      class="mt-2 ml-2"
                      v-model="posterName"
                      block
                    ></v-text-field>
                    <v-text-field
                      v-if="posterCategoryIdx == 4 || posterCategoryIdx == 9"
                      label="회사명"
                      placeholder="회사명을 입력하세요."
                      class="mt-2 ml-2"
                      v-model="companyName"
                      block
                    ></v-text-field>
                    <v-text-field
                      v-if="posterCategoryIdx == 4 || posterCategoryIdx == 9"
                      label="지역"
                      placeholder="지역을 입력하세요."
                      class="mt-2 ml-2"
                      v-model="regionName"
                      block
                    ></v-text-field>
                    <v-row>
                      <span class="col-12 rem-1 mt-2 pl-0 text-left"
                        >홍보 시작일 당일에 대다수의 학생에게 노출됩니다</span
                      >
                      <v-col cols="6" class="px-1">
                        <v-dialog
                          ref="dialog1"
                          v-model="menu1"
                          persistent
                          :return-value.sync="publicOpenStartDate"
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="publicOpenStartDate"
                              label="희망 홍보시작일"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="publicOpenStartDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu1 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog1.save(publicOpenStartDate)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>

                      <v-col cols="6" class="px-1">
                        <v-dialog
                          ref="dialog2"
                          v-model="menu2"
                          persistent
                          :return-value.sync="publicOpenEndDate"
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="publicOpenEndDate"
                              label="희망 홍보마감일"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="publicOpenEndDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu2 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog2.save(publicOpenEndDate)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>

                      <v-col cols="6" class="px-1">
                        <v-dialog
                          ref="dialog3"
                          v-model="menu3"
                          persistent
                          :return-value.sync="posterStartDate"
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="posterStartDate"
                              label="모집시간 시작일(선택)"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="posterStartDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu3 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog3.save(posterStartDate)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>

                      <v-col cols="6" class="px-1">
                        <v-dialog
                          ref="dialog4"
                          v-model="menu4"
                          persistent
                          :return-value.sync="posterEndDate"
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="posterEndDate"
                              label="모집시간 마감일"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="posterEndDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu4 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog4.save(posterEndDate)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                      <v-col cols="6" class="px-1">
                        <v-dialog
                          ref="dialog5"
                          v-model="timeModal"
                          :return-value.sync="documentDate"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="documentDate"
                              label="지원 마감시간(선택)"
                              prepend-icon="access_time"
                              readonly
                              v-on="on"
                            >
                            </v-text-field>
                          </template>
                          <v-time-picker
                            v-if="timeModal"
                            v-model="documentDate"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="timeModal = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog5.save(documentDate)"
                              >OK</v-btn
                            >
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </div>
                </v-row>

                <v-row class="mt-5">
                  <span class="col-12 rem-2 mt-5 text-left m_title"
                    >3. 포스터 요약 정보</span
                  >
                  <span class="col-12 rem-1 pt-0 text-left m_subtitle"
                    >학생들이 한 눈에 읽을 수 있도록 정보를 3줄 이내로 짧게
                    요약하여 입력해주세요</span
                  >
                  <div class="col-xl-3 col-sm-3 col-xs-12 text-center mt-4">
                    <img src="/images/preview1_1.jpg" width="100%" />
                  </div>
                  <div
                    v-if="posterCategoryIdx == 0"
                    class="col-xl-9 col-sm-9 col-xs-12 mt-4"
                  >
                    <v-row>
                      <!-- 공모전 -->
                      <v-textarea
                        v-model="outline"
                        counter
                        outlined
                        label="주제"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="target"
                        counter
                        outlined
                        label="지원자격"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="benefit"
                        counter
                        outlined
                        label="시상내역"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                    </v-row>
                  </div>
                  <div
                    v-if="posterCategoryIdx == 1"
                    class="col-xl-9 col-sm-9 col-xs-12 mt-4"
                  >
                    <v-row>
                      <!-- 대외활동 -->
                      <v-textarea
                        v-model="outline"
                        counter
                        outlined
                        label="지원자격"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="target"
                        counter
                        outlined
                        label="활동내용"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="benefit"
                        counter
                        outlined
                        label="혜택"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                    </v-row>
                  </div>
                  <div
                    v-if="posterCategoryIdx == 2"
                    class="col-xl-9 col-sm-9 col-xs-12 mt-4"
                  >
                    <v-row>
                      <!-- 동아리 -->
                      <v-textarea
                        v-model="outline"
                        counter
                        outlined
                        label="활동분야"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="period"
                        counter
                        outlined
                        label="활동시간"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="benefit"
                        counter
                        outlined
                        label="혜택"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                    </v-row>
                  </div>
                  <div
                    v-if="posterCategoryIdx == 4 || posterCategoryIdx == 9"
                    class="col-xl-9 col-sm-9 col-xs-12 mt-4"
                  >
                    <v-row>
                      <!-- 인턴 -->
                      <v-textarea
                        v-model="outline"
                        counter
                        outlined
                        label="모집분야"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="target"
                        counter
                        outlined
                        label="지원자격"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="benefit"
                        counter
                        outlined
                        label="근무조건"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                    </v-row>
                  </div>
                  <div
                    v-if="posterCategoryIdx == 7"
                    class="col-xl-9 col-sm-9 col-xs-12 mt-4"
                  >
                    <v-row>
                      <!-- 교육/강연 -->
                      <v-textarea
                        v-model="outline"
                        counter
                        outlined
                        label="주제"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="target"
                        counter
                        outlined
                        label="내용/커리큘럼"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-textarea
                        v-model="period"
                        counter
                        outlined
                        label="일정/기간"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                    </v-row>
                  </div>
                  <div
                    v-if="posterCategoryIdx == 5"
                    class="col-xl-9 col-sm-9 col-xs-12 mt-4"
                  >
                    <v-row>
                      <v-text-field
                        label="항목이름1"
                        outlined
                        hint="항목이름을 입력해주세요."
                        class="mt-2"
                        v-model="columnName1"
                        block
                      ></v-text-field>
                      <!-- 기타 -->
                      <v-textarea
                        v-model="columnContent1"
                        counter
                        outlined
                        label="항목내용1"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-text-field
                        label="항목이름2"
                        outlined
                        hint="항목이름을 입력해주세요."
                        class="mt-2"
                        v-model="columnName2"
                        block
                      ></v-text-field>
                      <v-textarea
                        v-model="columnContent2"
                        counter
                        outlined
                        label="항목내용2"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-text-field
                        label="항목이름3"
                        outlined
                        hint="항목이름을 입력해주세요."
                        class="mt-2"
                        v-model="columnName3"
                        block
                      ></v-text-field>
                      <v-textarea
                        v-model="columnContent3"
                        counter
                        outlined
                        label="항목내용3"
                        rows="4"
                        auto-grow
                        :rules="columnRules"
                        class="col-12 mt-2"
                      ></v-textarea>
                    </v-row>
                  </div>
                </v-row>

                <v-row class="mt-5">
                  <span class="col-12 rem-2 mt-5 text-left m_title"
                    >4. 포스터 상세 정보</span
                  >
                  <span class="col-12 rem-1 pt-0 text-left m_subtitle"
                    >자세한 정보를 확인할 수 있도록 자세한 행사/모집 정보를
                    입력해주세요</span
                  >
                  <v-col cols="4" class="mt-2">
                    <img src="/images/preview1_2.jpg" width="100%" />
                  </v-col>
                  <v-col cols="8" class="mt-2">
                    <v-row>
                      <v-textarea
                        v-model="posterDetail"
                        outlined
                        label="자세히 보기 내용"
                        rows="20"
                        auto-grow
                        class="col-12 mt-2"
                      ></v-textarea>
                      <v-text-field
                        label="포스터 관련 사이트 주소"
                        outlined
                        hint="사이트 주소를 입력해주세요."
                        class="mt-2 col-12"
                        v-model="posterWebsite"
                      ></v-text-field>
                      <v-text-field
                        label="바로 지원 사이트 주소"
                        outlined
                        hint="사이트 주소를 입력해주세요."
                        class="mt-2 col-12"
                        v-model="posterWebsite2"
                      ></v-text-field>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="mt-5">
                  <span class="col-12 rem-2 mt-5 text-left m_title"
                    >4-2. 포스터 추가 이미지(선택)</span
                  >
                  <span class="col-12 rem-1 pt-0 text-left m_subtitle"
                    >추가로 삽입하실 이미지를 업로드 해주세요</span
                  >
                  <v-col cols="12" md="3" class="mt-2">
                    <img src="/images/preview_detail.jpg" width="100%" />
                  </v-col>
                  <v-col cols="12" md="9" class="mt-2">
                    <v-row
                      v-if="reUpload2 || photoUrl2 == '' || photoUrl2 == null"
                    >
                      <v-file-input
                        accept="image/*"
                        dense
                        label="File input"
                        class="col-12 col-md-4"
                        v-model="file"
                      ></v-file-input>
                      <v-col cols="12" md="2">
                        <v-btn
                          class="px-1 bg-main-dark text-white"
                          block
                          outlined
                          v-on:click="upload2()"
                          >이미지 저장</v-btn
                        >
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          class="px-1 bg-main-dark-opac-15 text-main"
                          block
                          outlined
                          v-on:click="reUpload2 = false"
                          >취소</v-btn
                        >
                      </v-col>
                      <img
                        v-if="photoUrl2 != '' || reUpload2"
                        :src="photoUrl2"
                        width="100%"
                        class="col-12 col-md-8"
                      />
                    </v-row>
                    <v-row v-else>
                      <img
                        v-if="photoUrl2 != ''"
                        :src="photoUrl2"
                        width="100%"
                        class="col-12 col-md-8"
                      />
                      <v-col cols="12" md="8">
                        <v-btn
                          class="px-1 bg-main-dark text-white"
                          block
                          outlined
                          v-on:click="reUpload2 = true"
                          >다른 이미지로 재등록</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="mt-5">
                  <span class="col-12 rem-2 mt-5 text-left m_title"
                    >5. 분야 설정 및 타겟팅</span
                  >
                  <span class="col-12 rem-1 pt-0 pb-0 text-left m_subtitle"
                    >타겟팅을 위한 상세 정보 및 분야를 입력해주세요</span
                  >
                  <span class="col-12 rem-1 pt-0 text-left m_subtitle"
                    >유저가 회원가입 시 설정해 놓은 관심 분야를 기반으로 해당
                    포스터가 추천됩니다</span
                  >
                </v-row>

                <v-row v-if="userinfo.authAdmin == 2" class="mt-2">
                  <label
                    class="col-12 text-left mt-2 rem-1"
                    for="mandatoryChecked"
                    ><b>무조건 공개</b>(관리자전용)</label
                  >
                  <input
                    class="col-12 text-left"
                    type="checkbox"
                    id="mandatoryChecked"
                    v-model="mandatoryChecked"
                  />
                </v-row>

                <v-row v-if="posterCategoryIdx != 2" class="mt-2">
                  <span class="col-12 rem-1 mt-2 pb-1 text-left">주최기관</span>
                  <v-col cols="12" sm="4" md="2" class="pt-0">
                    <v-btn
                      :class="
                        hostIdx == 10000
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="hostIdx = 10000"
                      >대기업</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="4" md="2" class="pt-0">
                    <v-btn
                      :class="
                        hostIdx == 20000
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="hostIdx = 20000"
                      >중견기업</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="4" md="2" class="pt-0">
                    <v-btn
                      :class="
                        hostIdx == 30000
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="hostIdx = 30000"
                      >강소기업</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="4" md="2" class="pt-0">
                    <v-btn
                      :class="
                        hostIdx == 40000
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="hostIdx = 40000"
                      >스타트업</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="4" md="2" class="pt-0">
                    <v-btn
                      :class="
                        hostIdx == 50000
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="hostIdx = 50000"
                      >공사/공기업</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="4" md="2" class="pt-0">
                    <v-btn
                      :class="
                        hostIdx == 60000
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="hostIdx = 60000"
                      >외국계기업</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="4" md="2" class="pt-0">
                    <v-btn
                      :class="
                        hostIdx == 95000
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="hostIdx = 95000"
                      >기타</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row v-if="posterCategoryIdx == 2" class="mt-2 px-2">
                  <v-col cols="12" sm="4" class="p-1">
                    <v-btn
                      :class="
                        posterSubCategoryIdx == 0
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="clickSub(0)"
                      >연합 동아리</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="4" class="p-1">
                    <v-btn
                      :class="
                        posterSubCategoryIdx == 1
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="clickSub(1)"
                      >교내 동아리</v-btn
                    >
                  </v-col>
                </v-row>

                <v-row class="mt-2">
                  <span class="col-12 rem-1 mt-2 pb-1 text-left"
                    >타겟 대학 설정</span
                  >
                  <v-col cols="12" sm="4" class="p-1">
                    <v-btn
                      :class="
                        isOnlyUniv == 0
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="clickIsOnlyUniv(0)"
                      >지역별</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="4" class="p-1">
                    <v-btn
                      :class="
                        isOnlyUniv == 1
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="clickIsOnlyUniv(1)"
                      >직접입력</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row v-if="isOnlyUniv == 0" class="mt-2 px-2">
                  <!-- <span class="col-12 subtitle-2 mt-2 pb-1 text-left">활동지역(중복 선택)</span> -->
                  <v-btn
                    :class="
                      interestList.indexOf(900) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(900)"
                    >전국</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(901) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(901)"
                    >서울</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(902) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(902)"
                    >부산</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(903) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(903)"
                    >대구</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(904) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(904)"
                    >인천</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(905) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(905)"
                    >광주</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(906) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(906)"
                    >대전</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(907) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(907)"
                    >울산</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(908) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(908)"
                    >경기</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(909) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(909)"
                    >강원</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(910) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(910)"
                    >충남</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(911) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(911)"
                    >충북</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(912) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(912)"
                    >전남</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(913) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(913)"
                    >전북</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(914) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(914)"
                    >경남</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(915) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(915)"
                    >경북</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(916) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(916)"
                    >제주</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(917) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(917)"
                    >세종</v-btn
                  >
                </v-row>
                <v-row v-if="isOnlyUniv == 1" class="mt-2">
                  <v-col cols="8">
                    <autocomplete
                      ref="autocomplete"
                      :source="univData"
                      results-display="univName"
                      placeholder="대학교 검색 후 아래에서 선택해주세요"
                      input-class="form-control"
                      @selected="addUnivList"
                    >
                    </autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <span
                    v-for="(univ, index) in univList"
                    class="mt-1 ml-1 mr-1 border-main-rounded text-main"
                    >{{ univ
                    }}<button
                      type="button"
                      v-on:click="deleteUniv(index)"
                      class="close"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </span>
                </v-row>

                <v-row class="mt-2">
                  <span class="col-12 rem-1 mt-2 pb-1 text-left"
                    >타겟 학과 설정</span
                  >
                  <v-col sm="4" class="p-1">
                    <v-btn
                      :class="
                        isOnlyMajor == 0
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="clickIsOnlyMajor(0)"
                      >모든 계열</v-btn
                    >
                  </v-col>
                  <v-col sm="4" class="p-1">
                    <v-btn
                      :class="
                        isOnlyMajor == 1
                          ? 'px-1 bg-main-dark-opac-15 text-main'
                          : 'px-1 text-grey-2 border-grey-3'
                      "
                      block
                      outlined
                      v-on:click="clickIsOnlyMajor(1)"
                      >특정 계열</v-btn
                    >
                  </v-col>
                </v-row>

                <v-row v-if="isOnlyMajor == 1" class="mt-2 px-2">
                  <v-btn
                    :class="
                      majorCategorySelected[0] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory1(0)"
                    >공학계열</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[0] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    v-if="majorCategorySelected[0] == 1"
                    v-for="(major2, index) in majorList[0].majorCategory2"
                    :class="
                      majorList[0].selected[index] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory2(0, index)"
                    >{{ major2 }}</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[0] == 1"
                    class="col-12"
                  ></div>

                  <div
                    v-if="majorCategorySelected[1] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    :class="
                      majorCategorySelected[1] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory1(1)"
                    >자연과학계열</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[1] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    v-if="majorCategorySelected[1] == 1"
                    v-for="(major2, index) in majorList[1].majorCategory2"
                    :class="
                      majorList[1].selected[index] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory2(1, index)"
                    >{{ major2 }}</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[1] == 1"
                    class="col-12"
                  ></div>

                  <div
                    v-if="majorCategorySelected[2] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    :class="
                      majorCategorySelected[2] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory1(2)"
                    >인문사회계열</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[2] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    v-if="majorCategorySelected[2] == 1"
                    v-for="(major2, index) in majorList[2].majorCategory2"
                    :class="
                      majorList[2].selected[index] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory2(2, index)"
                    >{{ major2 }}</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[2] == 1"
                    class="col-12"
                  ></div>

                  <div
                    v-if="majorCategorySelected[3] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    :class="
                      majorCategorySelected[3] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory1(3)"
                    >예체능계열</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[3] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    v-if="majorCategorySelected[3] == 1"
                    v-for="(major2, index) in majorList[3].majorCategory2"
                    :class="
                      majorList[3].selected[index] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory2(3, index)"
                    >{{ major2 }}</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[3] == 1"
                    class="col-12"
                  ></div>

                  <div
                    v-if="majorCategorySelected[4] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    :class="
                      majorCategorySelected[4] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory1(4)"
                    >의학계열</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[4] == 1"
                    class="col-12"
                  ></div>
                  <v-btn
                    v-if="majorCategorySelected[4] == 1"
                    v-for="(major2, index) in majorList[4].majorCategory2"
                    :class="
                      majorList[4].selected[index] == 1
                        ? 'mx-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickMajorCategory2(4, index)"
                    >{{ major2 }}</v-btn
                  >
                  <div
                    v-if="majorCategorySelected[4] == 1"
                    class="col-12"
                  ></div>
                </v-row>

                <v-row class="mt-2">
                  <span
                    v-if="
                      posterCategoryIdx == 0 ||
                        posterCategoryIdx == 1 ||
                        posterCategoryIdx == 2 ||
                        posterCategoryIdx == 7
                    "
                    class="col-12 rem-1 mt-2 pb-1 text-left"
                    >카테고리</span
                  >
                </v-row>
                <v-row class="px-2">
                  <v-btn
                    v-if="posterCategoryIdx == 0 || posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(201) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(201)"
                    >기획/아이디어</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 0 || posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(202) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(202)"
                    >광고/마케팅</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 0 || posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(206) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(206)"
                    >영상/콘텐츠</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 0 || posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(205) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(205)"
                    >디자인</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 0 || posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(207) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(207)"
                    >IT/SW</v-btn
                  >

                  <v-btn
                    v-if="posterCategoryIdx == 0"
                    :class="
                      interestList.indexOf(204) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(204)"
                    >문학/시나리오</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 0"
                    :class="
                      interestList.indexOf(208) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(208)"
                    >스타트업/창업</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 0"
                    :class="
                      interestList.indexOf(215) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(215)"
                    >금융/경제</v-btn
                  >

                  <v-btn
                    v-if="posterCategoryIdx == 0"
                    :class="
                      interestList.indexOf(299) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(299)"
                    >기타</v-btn
                  >

                  <v-btn
                    v-if="posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(213) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(213)"
                    >뷰티/패션</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(217) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(217)"
                    >스포츠/레저</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(253) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(253)"
                    >해외탐방</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(218) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(218)"
                    >봉사활동</v-btn
                  >

                  <v-btn
                    v-if="posterCategoryIdx == 1"
                    :class="
                      interestList.indexOf(999) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(299)"
                    >기타</v-btn
                  >

                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(401) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(401)"
                    >문화생활</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(402) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(402)"
                    >스포츠</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(403) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(403)"
                    >여행</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(404) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(404)"
                    >음악/예술</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(405) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(405)"
                    >봉사</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(406) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(406)"
                    >스터디/학회</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(407) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(407)"
                    >어학</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(408) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(408)"
                    >창업</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(409) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(409)"
                    >친목</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(410) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(410)"
                    >IT/공학</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 2"
                    :class="
                      interestList.indexOf(411) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(411)"
                    >기타</v-btn
                  >

                  <v-btn
                    v-if="posterCategoryIdx == 7"
                    :class="
                      interestList.indexOf(601) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(601)"
                    >IT/개발</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 7"
                    :class="
                      interestList.indexOf(602) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(602)"
                    >마케팅</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 7"
                    :class="
                      interestList.indexOf(603) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(603)"
                    >기획/PM</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 7"
                    :class="
                      interestList.indexOf(604) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(604)"
                    >디자인</v-btn
                  >
                  <v-btn
                    v-if="posterCategoryIdx == 7"
                    :class="
                      interestList.indexOf(699) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(699)"
                    >기타</v-btn
                  >
                </v-row>

                <v-row v-if="posterCategoryIdx == 1" class="mt-2">
                  <span class="col-12 rem-1 mt-5 pb-1 text-left"
                    >대외활동 분류</span
                  >
                </v-row>
                <v-row v-if="posterCategoryIdx == 1" class="px-2">
                  <v-btn
                    :class="
                      interestList.indexOf(251) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(251)"
                    >서포터즈</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(252) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(252)"
                    >봉사활동</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(255) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(255)"
                    >리뷰/체험단</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(254) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(254)"
                    >해외봉사/탐방</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(299) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(299)"
                    >기타</v-btn
                  >
                </v-row>

                <v-row
                  v-if="posterCategoryIdx == 4 || posterCategoryIdx == 9"
                  class="mt-2"
                >
                  <span class="col-12 rem-1 mt-5 pb-1 text-left">관심직무</span>
                </v-row>
                <v-row
                  v-if="posterCategoryIdx == 4 || posterCategoryIdx == 9"
                  class="px-2"
                >
                  <v-btn
                    :class="
                      interestList.indexOf(101) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(101)"
                    >경영/비즈니스</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(102) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(102)"
                    >영업</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(103) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(103)"
                    >제조/생산</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(104) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(104)"
                    >개발</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(106) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(106)"
                    >인사/교육</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(107) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(107)"
                    >미디어</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(109) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(109)"
                    >엔지니어링/설계</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(110) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(110)"
                    >마케팅/광고</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(111) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(111)"
                    >고객서비스/리테일</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(112) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(112)"
                    >디자인</v-btn
                  >
                  <v-btn
                    :class="
                      interestList.indexOf(199) != -1
                        ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main'
                        : 'mx-1 mt-1 text-grey-2 border-grey-3'
                    "
                    outlined
                    v-on:click="clickInterest(199)"
                    >기타</v-btn
                  >
                </v-row>

                <v-row class="mt-2">
                  <span class="col-12 rem-1 mt-2 pb-1 text-left"
                    >해시태그 입력</span
                  >
                  <v-text-field
                    label="해시태그"
                    outlined
                    dense
                    hint="예시) #빅데이터 #데이터분석"
                    class="mt-2 ml-2 col-8"
                    v-model="keyword"
                  ></v-text-field>
                </v-row>

                <v-row
                  v-if="userinfo.authAdmin == 1 || userinfo.authAdmin == 2"
                  class="mt-2"
                >
                  <span class="col-12 rem-1 mt-2 pb-1 text-left"
                    >담당자 확인</span
                  >
                </v-row>
                <v-row
                  v-if="userinfo.authAdmin == 1 || userinfo.authAdmin == 2"
                  class="px-2"
                >
                  <v-text-field
                    label="주최기관명"
                    outlined
                    hint="주최기관명을 입력해주세요."
                    class="mt-2 col-8"
                    v-model="hostName"
                    block
                  ></v-text-field>
                  <v-text-field
                    label="담당자명"
                    outlined
                    hint="담당자명을 입력해주세요."
                    class="mt-2 col-8"
                    v-model="chargerName"
                    block
                  ></v-text-field>
                  <v-text-field
                    label="연락처"
                    outlined
                    hint="연락처를 입력해주세요."
                    class="mt-2 col-8"
                    v-model="partnerPhone"
                    block
                  ></v-text-field>
                  <v-text-field
                    label="담당자 이메일"
                    outlined
                    hint="담당자 이메일을 입력해주세요."
                    class="mt-2 col-8"
                    v-model="partnerEmail"
                    block
                  ></v-text-field>
                </v-row>

                <v-row v-if="userinfo && posterInfo">
                  <v-col cols="3" md="2" class="ml-0">
                    <v-btn
                      class="bg-grey text-white border-rounded30"
                      block
                      :height="60"
                      v-on:click="goback"
                      >돌아가기</v-btn
                    >
                  </v-col>
                  <v-col
                    v-if="
                      userinfo.authAdmin == 2 ||
                        (userinfo.partnerIdx ==
                          posterInfo.posterDetailInfo.partnerIdx &&
                          posterInfo.posterDetailInfo.adminAccept == 0)
                    "
                    cols="3"
                    md="2"
                    class="ml-0 mr-auto"
                  >
                    <v-dialog v-model="deleteDialog" max-width="290">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="bg-dark text-white border-rounded30"
                          block
                          :height="60"
                          v-on="on"
                          >포스터 삭제</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>주의</v-card-title>
                        <v-card-text>
                          <span class="mt-5">정말 삭제하시겠습니까?</span>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="text-main" @click="deletePoster()"
                            >예</v-btn
                          >
                          <v-btn
                            class="text-grey-1"
                            @click="deleteDialog = false"
                            >아니요</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>

                  <v-col
                    v-if="
                      userinfo.authAdmin == 2 &&
                        posterInfo.posterDetailInfo.adminAccept == 1
                    "
                    cols="3"
                    md="2"
                    class="mr-0 ml-auto"
                  >
                    <v-dialog v-model="advertAcceptDialog" max-width="290">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="bg-main text-white border-rounded30"
                          block
                          :height="60"
                          v-on="on"
                        >
                          <span>광고 승인</span>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>주의</v-card-title>
                        <v-card-text>
                          <span class="mt-5">
                            정말 광고 승인을 진행하시겠습니까?
                          </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="text-main" @click="adminAcceptPoster(2)"
                            >예</v-btn
                          >
                          <v-btn
                            class="text-grey-1"
                            @click="advertAcceptDialog = false"
                            >아니요</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>

                  <v-col
                    v-if="userinfo.authAdmin == 2"
                    cols="3"
                    md="2"
                    class="mr-0"
                  >
                    <v-dialog v-model="adminAcceptDialog" max-width="290">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="bg-main text-white border-rounded30"
                          block
                          :height="60"
                          v-on="on"
                        >
                          <span
                            v-if="posterInfo.posterDetailInfo.adminAccept >= 1"
                            >승인 취소</span
                          >
                          <span v-else>승인</span>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>주의</v-card-title>
                        <v-card-text>
                          <span
                            v-if="posterInfo.posterDetailInfo.adminAccept >= 1"
                            class="mt-5"
                          >
                            정말 승인 취소하시겠습니까?
                          </span>
                          <span v-else class="mt-5">
                            정말 승인하시겠습니까?
                          </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="posterInfo.posterDetailInfo.adminAccept >= 1"
                            class="text-main"
                            @click="adminAcceptPoster(0)"
                            >예</v-btn
                          >
                          <v-btn
                            v-else
                            class="text-main"
                            @click="adminAcceptPoster(1)"
                            >예</v-btn
                          >
                          <v-btn
                            class="text-grey-1"
                            @click="adminAcceptDialog = false"
                            >아니요</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>

                  <v-col
                    v-if="
                      userinfo.authAdmin == 2 ||
                        userinfo.partnerIdx ==
                          posterInfo.posterDetailInfo.partnerIdx
                    "
                    cols="3"
                    md="2"
                    class="mr-0"
                  >
                    <v-dialog
                      v-if="posterInfo"
                      v-model="reportDialog"
                      width="100%"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="green lighten-2 text-white border-rounded30"
                          block
                          :height="60"
                          v-on="on"
                        >
                          광고 보고서
                        </v-btn>
                      </template>

                      <v-card v-if="analyticsJson.majorCategory[0] != '계산중'">
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title
                        >
                          광고 보고서
                        </v-card-title>

                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <div
                              class="text-main rem-1_5 text-left ml-2 mt-5 pb-0"
                            >
                              <b>순위</b>
                            </div>
                            <div class="rem-1 text-left ml-2 pt-0">
                              해당 포스터를 저장한 유저의 대학교, 학과, 학년,
                              나이, 성별 순위입니다.
                            </div>
                            <v-card elevation="5" class="mx-2 mt-5">
                              <v-card-title>대학교</v-card-title>
                              <hr class="hr-main" />
                              <v-list inset>
                                <v-list-item v-for="i in 3">
                                  <v-list-item-content
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{ i }}위:
                                    {{
                                      analyticsJson.univ[i - 1]
                                    }}</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{ analyticsJson.univRate[i - 1] }}%,
                                    {{
                                      analyticsJson.univNum[i - 1]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-else
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{
                                      analyticsJson.univRate[i - 1]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content
                                    >기타</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    class="align-end"
                                    >{{ analyticsJson.univRate[3] }}%,
                                    {{
                                      analyticsJson.univNum[3]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content v-else class="align-end"
                                    >{{
                                      analyticsJson.univRate[3]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                              </v-list>
                            </v-card>
                            <v-card elevation="5" class="mx-2 mt-5">
                              <v-card-title>학과</v-card-title>
                              <hr class="hr-main" />
                              <v-list inset>
                                <v-list-item v-for="i in 3">
                                  <v-list-item-content
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{ i }}위:
                                    {{
                                      analyticsJson.majorCategory[i - 1]
                                    }}</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{
                                      analyticsJson.majorCategoryRate[i - 1]
                                    }}%,
                                    {{
                                      analyticsJson.majorCategoryNum[i - 1]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-else
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{
                                      analyticsJson.majorCategoryRate[i - 1]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content
                                    >기타</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    class="align-end"
                                    >{{ analyticsJson.majorCategoryRate[3] }}%,
                                    {{
                                      analyticsJson.majorCategoryNum[3]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content v-else class="align-end"
                                    >{{
                                      analyticsJson.majorCategoryRate[3]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                              </v-list>
                            </v-card>
                            <v-card elevation="5" class="mx-2 mt-5">
                              <v-card-title>나이</v-card-title>
                              <hr class="hr-main" />
                              <v-list inset>
                                <v-list-item v-for="i in 3">
                                  <v-list-item-content
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{ i }}위:
                                    {{
                                      analyticsJson.age[i - 1]
                                    }}</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{ analyticsJson.ageRate[i - 1] }}%,
                                    {{
                                      analyticsJson.ageNum[i - 1]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-else
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{
                                      analyticsJson.ageRate[i - 1]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content
                                    >기타</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    class="align-end"
                                    >{{ analyticsJson.ageRate[3] }}%,
                                    {{
                                      analyticsJson.ageNum[3]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content v-else class="align-end"
                                    >{{
                                      analyticsJson.ageRate[3]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                              </v-list>
                            </v-card>
                            <v-card elevation="5" class="mx-2 mt-5">
                              <v-card-title>학년</v-card-title>
                              <hr class="hr-main" />
                              <v-list inset>
                                <v-list-item v-for="i in 3">
                                  <v-list-item-content
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{ i }}위:
                                    {{
                                      analyticsJson.grade[i - 1]
                                    }}</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{ analyticsJson.univRate[i - 1] }}%,
                                    {{
                                      analyticsJson.univNum[i - 1]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-else
                                    :class="
                                      i == 1
                                        ? 'align-end text-main'
                                        : 'align-end'
                                    "
                                    >{{
                                      analyticsJson.univRate[i - 1]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content
                                    >기타</v-list-item-content
                                  >
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    class="align-end"
                                    >{{ analyticsJson.gradeRate[3] }}%,
                                    {{
                                      analyticsJson.gradeNum[3]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content v-else class="align-end"
                                    >{{
                                      analyticsJson.gradeRate[3]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                              </v-list>
                            </v-card>
                            <v-card elevation="5" class="mx-2 mt-5">
                              <v-card-title>성별</v-card-title>
                              <hr class="hr-main" />
                              <v-list inset>
                                <v-list-item>
                                  <v-list-item-content class="align-end">{{
                                    analyticsJson.gender[0]
                                  }}</v-list-item-content>
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    class="align-end"
                                    >{{ analyticsJson.genderRate[0] }}%,
                                    {{
                                      analyticsJson.genderNum[0]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content v-else class="align-end"
                                    >{{
                                      analyticsJson.genderRate[0]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content class="align-end">{{
                                    analyticsJson.gender[1]
                                  }}</v-list-item-content>
                                  <v-list-item-content
                                    v-if="userinfo.authAdmin == 2"
                                    class="align-end"
                                    >{{ analyticsJson.genderRate[1] }}%,
                                    {{
                                      analyticsJson.genderNum[1]
                                    }}명</v-list-item-content
                                  >
                                  <v-list-item-content v-else class="align-end"
                                    >{{
                                      analyticsJson.genderRate[1]
                                    }}%</v-list-item-content
                                  >
                                </v-list-item>
                              </v-list>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm6 v-if="userinfo.authAdmin == 2">
                            <v-card-title
                              ><span class="text-main"><b>활성 유저수</b></span
                              >&nbsp;&nbsp;
                              {{ analyticsJson.activeUserNum }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"><b>상세조회수</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.detailShowNum +
                                  posterInfo.posterDetailInfo.detailShowNum2 +
                                  posterInfo.posterDetailInfo.detailShowNum3
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>상세조회수(앱 캘린더에서)</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.detailShowNum
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>상세조회수(앱 뭐하지뷰에서)</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.detailShowNum2
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>상세조회수(앱 전체뷰에서)</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.detailShowNum3
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>스와이프 수(앱)</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.swipeNum
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>좋아요 수(앱)</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.likeNum
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>캘린더 저장 수(앱)</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.saveNum
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>캘린더 저장한 유저 중 상세 조회 수</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.saveAndShowNum
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>즐겨찾기 수(앱)</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.favoriteNum
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"
                                ><b>웹사이트 클릭 수(앱)</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.websiteClickNum
                              }}</v-card-title
                            >
                            <v-card-title
                              ><span class="text-main"><b>저장 비율</b></span
                              >&nbsp;&nbsp;
                              {{
                                String(
                                  (this.posterInfo.posterDetailInfo.saveNum /
                                    this.posterInfo.posterDetailInfo.swipeNum) *
                                    100
                                ).substr(0, 4) + "%"
                              }}</v-card-title
                            >
                            <bar-chart
                              :chartdata="chartdata"
                              :options="options"
                            ></bar-chart>
                          </v-flex>
                          <v-flex xs12 sm6 v-else>
                            <v-card-title class="pb-0"
                              ><span class="text-main"><b>활성 유저수</b></span
                              >&nbsp;&nbsp;
                              {{ analyticsJson.activeUserNum }}</v-card-title
                            >
                            <v-card-title class="pt-0"
                              ><span class="rem-1"
                                >광고 기간 동안 슥삭 앱을 사용한
                                유저수입니다.</span
                              ></v-card-title
                            >

                            <v-card-title class="pb-0"
                              ><span class="text-main"
                                ><b>누적 광고 조회수</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.detailShowNum +
                                  posterInfo.posterDetailInfo.detailShowNum2 +
                                  posterInfo.posterDetailInfo.detailShowNum3 +
                                  posterInfo.posterDetailInfo.swipeNum
                              }}</v-card-title
                            >
                            <v-card-title class="pt-0"
                              ><span class="rem-1"
                                >슥삭 앱의 추천 탭, 전체 탭, 캘린더 탭에서
                                유저가 해당 포스터를 조회한 총 횟수입니다.</span
                              ></v-card-title
                            >

                            <v-card-title class="pb-0"
                              ><span class="text-main"><b>타겟 유저수</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.swipeNum
                              }}</v-card-title
                            >
                            <v-card-title class="pt-0"
                              ><span class="rem-1"
                                >관심사에 따라 해당 포스터가 추천된 유저의
                                수입니다.</span
                              ></v-card-title
                            >

                            <v-card-title class="pb-0"
                              ><span class="text-main"><b>광고 저장수</b></span
                              >&nbsp;&nbsp;
                              {{
                                posterInfo.posterDetailInfo.saveNum
                              }}</v-card-title
                            >
                            <v-card-title class="pt-0"
                              ><span class="rem-1"
                                >타겟 유저 중에서 해당 포스터를 캘린더에 저장한
                                유저의 수입니다.</span
                              ></v-card-title
                            >

                            <v-card-title class="pb-0"
                              ><span class="text-main"><b>저장 비율</b></span
                              >&nbsp;&nbsp;
                              {{
                                String(
                                  (this.posterInfo.posterDetailInfo.saveNum /
                                    this.posterInfo.posterDetailInfo.swipeNum) *
                                    100
                                ).substr(0, 4) + "%"
                              }}</v-card-title
                            >
                            <bar-chart
                              :chartdata="chartdata"
                              :options="options"
                            ></bar-chart>
                          </v-flex>
                        </v-layout>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            text
                            @click="reportDialog = false"
                          >
                            닫기
                          </v-btn>
                        </v-card-actions>
                      </v-card>

                      <v-card v-else>
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title
                        >
                          광고 보고서
                        </v-card-title>

                        <v-card-text>
                          아직 충분한 양의 데이터가 없거나 게재되지 않은
                          광고입니다.
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            text
                            @click="reportDialog = false"
                          >
                            닫기
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                  <v-col
                    v-if="
                      userinfo.authAdmin == 2 ||
                        userinfo.partnerIdx ==
                          posterInfo.posterDetailInfo.partnerIdx
                    "
                    cols="3"
                    md="2"
                    class="mr-0"
                  >
                    <v-btn
                      class="bg-main-dark text-white border-main-rounded30"
                      block
                      :height="60"
                      outlined
                      v-on:click="updatePoster"
                      >포스터 수정</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </v-container>
            <Footer class="mt-5"></Footer>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-app>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import Tabbar from "../components/Tabbar.vue";
import Footer from "../components/Footer.vue";
import { mapGetters } from "vuex";
import Autocomplete from "vuejs-auto-complete";
import majorCategory from "../assets/data/2019MajorCategory1and2.js";
import univData from "../assets/data/2019OnlyUniv.js";
import BarChart from "../components/BarChart.vue";
import DoughnutChart from "../components/DoughnutChart.vue";

export default {
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.posterIdx = this.$route.params.posterIdx;

    this.majorList = this.majorCategory;
    for (var i = 0; i < this.majorCategory.length; i++) {
      let tmpSelected = [];
      for (var j = 0; j < this.majorCategory[i].majorCategory2.length; j++) {
        tmpSelected.push(0);
      }
      this.majorList[i]["selected"] = tmpSelected;
    }

    this.$http.get("/api/posters/" + this.posterIdx).then(response => {
      if (response.data.status == 200) {
        this.posterInfo = response.data.data;
        this.posterCategoryIdx = this.posterInfo.posterDetailInfo.categoryIdx;
        this.posterSubCategoryIdx = this.posterInfo.posterDetailInfo.subCategoryIdx;
        this.hostIdx = this.posterInfo.posterDetailInfo.hostIdx;
        this.hostName = this.posterInfo.posterDetailInfo.hostName;
        this.chargerName = this.posterInfo.posterDetailInfo.chargerName;
        this.partnerPhone = this.posterInfo.posterDetailInfo.partnerPhone;
        this.partnerEmail = this.posterInfo.posterDetailInfo.partnerEmail;
        let posterInterest = this.posterInfo.posterInterest;

        for (var i = 0; i < posterInterest.length; i++) {
          this.interestList.push(posterInterest[i].interestIdx);
        }

        this.photoUrl = this.posterInfo.posterDetailInfo.photoUrl;
        this.thumbPhotoUrl = this.posterInfo.posterDetailInfo.thumbPhotoUrl;
        this.photoUrl2 = this.posterInfo.posterDetailInfo.photoUrl2;
        this.posterName = this.posterInfo.posterDetailInfo.posterName;
        this.publicOpenStartDate = this.posterInfo.posterDetailInfo.publicOpenStartDate;
        this.publicOpenEndDate = this.posterInfo.posterDetailInfo.publicOpenEndDate;
        this.posterStartDate = this.posterInfo.posterDetailInfo.posterStartDate;
        if (this.posterStartDate == "0000-00-00 00:00:00")
          this.posterStartDate = "";
        this.posterEndDate = this.posterInfo.posterDetailInfo.posterEndDate;
        this.documentDate = this.posterInfo.posterDetailInfo.documentDate;
        this.outline = this.posterInfo.posterDetailInfo.outline;
        this.target = this.posterInfo.posterDetailInfo.target;
        this.benefit = this.posterInfo.posterDetailInfo.benefit;
        this.period = this.posterInfo.posterDetailInfo.period;

        //기타 포스터일때
        if (this.posterCategoryIdx == 5) {
          this.columnName1 = this.posterInfo.posterDetailInfo.columnName1;
          this.columnContent1 = this.posterInfo.posterDetailInfo.columnContent1;

          this.columnName2 = this.posterInfo.posterDetailInfo.columnName2;
          this.columnContent2 = this.posterInfo.posterDetailInfo.columnContent2;

          this.columnName3 = this.posterInfo.posterDetailInfo.columnName3;
          this.columnContent3 = this.posterInfo.posterDetailInfo.columnContent3;
        }

        if (this.posterCategoryIdx == 4 || this.posterCategoryIdx == 9) {
          this.companyName = this.posterInfo.posterInternshipDetail.companyName;
          this.regionName = this.posterInfo.posterInternshipDetail.regionName;
        }

        this.posterDetail = this.posterInfo.posterDetailInfo.posterDetail;
        this.keyword = this.posterInfo.posterDetailInfo.keyword;
        this.posterWebsite = this.posterInfo.posterDetailInfo.posterWebsite;
        this.posterWebsite2 = this.posterInfo.posterDetailInfo.posterWebsite2;

        this.analyticsJson = JSON.parse(
          this.posterInfo.posterDetailInfo.analytics
        );

        this.adminAccept = this.posterInfo.posterDetailInfo.adminAccept;

        this.mandatoryShow = this.posterInfo.posterDetailInfo.mandatoryShow;
        if (this.mandatoryShow == 1) {
          this.mandatoryChecked = true;
        } else {
          this.mandatoryChecked = false;
        }

        this.isOnlyUniv = this.posterInfo.posterDetailInfo.isOnlyUniv;
        if (this.isOnlyUniv == 2) this.isOnlyUniv = 0;
        var posterUniv = this.posterInfo.posterUniversity;
        for (var i = 0; i < posterUniv.length; i++) {
          this.univList.push(posterUniv[i].univName);
        }

        this.isOnlyMajor = this.posterInfo.posterDetailInfo.isOnlyMajor;
        if (this.isOnlyMajor == 1) {
          for (var i = 0; i < this.posterInfo.posterMajor.length; i++) {
            var major1 = this.posterInfo.posterMajor[i].majorCategory1;
            var major2 = this.posterInfo.posterMajor[i].majorCategory2;
            for (var j = 0; j < this.majorList.length; j++) {
              if (this.majorList[j].majorCategory1 == major1) {
                for (
                  var k = 0;
                  k < this.majorList[j].majorCategory2.length;
                  k++
                ) {
                  if (this.majorList[j].majorCategory2[k] == major2) {
                    this.majorList[j].selected[k] = 1;
                    if (this.majorCategorySelected[j] == 0) {
                      this.majorCategorySelected[j] = 1;
                    }
                    break;
                  }
                }
                break;
              } else {
                continue;
              }
            }
          }
        }

        let tmpChartdata = {
          labels: [
            `타겟 유저수: ${this.posterInfo.posterDetailInfo.swipeNum}명`,
            `광고 저장수: ${this.posterInfo.posterDetailInfo.saveNum}명`
          ],
          datasets: [
            {
              label: "인원",
              backgroundColor: "#7279ff",
              data: [
                this.posterInfo.posterDetailInfo.swipeNum,
                this.posterInfo.posterDetailInfo.saveNum
              ]
            }
          ]
        };
        // this.chartdata.datasets.data = []
        // this.chartdata.datasets.data.push(this.posterInfo.posterDetailInfo.swipeNum)
        // this.chartdata.datasets.data.push(this.posterInfo.posterDetailInfo.saveNum)
        // let chartLabel = '저장비율: 0%'
        // if(this.posterInfo.posterDetailInfo.swipeNum != 0){
        //     chartLabel = '저장비율: ' + String(this.posterInfo.posterDetailInfo.saveNum / this.posterInfo.posterDetailInfo.swipeNum * 100).substr(0, 4) + '%'
        // }
        this.chartdata = tmpChartdata;
      } else {
        console.log(response);
      }
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      pagename: 1,
      window: {
        width: 0,
        height: 0
      },
      ismobile: false,

      drawer: false,
      group: null,

      posterIdx: null,
      posterCategoryIdx: null,
      posterSubCategoryIdx: 0,
      hostIdx: 10000,

      croppa: {},

      hostName: "",
      chargerName: "",
      partnerPhone: "",
      partnerEmail: "",
      interestList: [],
      photoUrl: "",
      thumbPhotoUrl: "",
      photoUrl2: "",
      posterName: "",
      publicOpenStartDate: "",
      publicOpenEndDate: "",
      posterStartDate: "",
      posterEndDate: "",
      documentDate: "",
      posterDetail: "",
      posterWebsite: "",
      posterWebsite2: "",
      companyName: "",
      regionName: "",

      keyword: "",

      outline: "",
      target: "",
      benefit: "",
      period: "",

      columnName1: "",
      columnContent1: "",
      columnName2: "",
      columnContent2: "",
      columnName3: "",
      columnContent3: "",

      isOnlyUniv: 0,
      isOnlyMajor: 0,
      univList: [],
      majorList: null,

      majorCategorySelected: [0, 0, 0, 0, 0],

      univData: univData,

      mandatoryShow: 0,
      mandatoryChecked: false,

      adminAccept: null,

      majorCategory: majorCategory,

      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      timeModal: false,
      file: null,

      columnRules: [
        v =>
          v.length <= 66 ||
          "* 글자 수 초과 시 기종에 따라 내용 일부가 표시되지 않을 수 있습니다"
      ],

      reUpload: false,
      reUpload2: false,

      reportDialog: false,
      deleteDialog: false,
      adminAcceptDialog: false,
      advertAcceptDialog: false,

      analyticsJson: null,

      chartdata: {
        labels: ["타겟 유저수", "광고 저장수"],
        datasets: [
          {
            label: "인원",
            backgroundColor: "#7279ff",
            data: []
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: true
        },
        responsive: false,
        maintainAspectRatio: false
      }
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "getUserInfo"
    }),
    getNowDate: function() {
      var timezoneOffset = new Date().getTimezoneOffset() * 60000;
      return new Date(Date.now() - timezoneOffset).toISOString().substr(0, 10);
    }
  },

  components: {
    Navbar,
    Tabbar,
    Footer,
    Autocomplete,
    BarChart,
    DoughnutChart
  },
  watch: {
    group() {
      this.drawer = false;
    },
    posterCategoryIdx: function(newVal, oldVal) {
      if (newVal == 2) {
        hostIdx = 90000;
      }
    },
    mandatoryChecked: function(newVal, oldVal) {
      if (newVal) {
        this.mandatoryShow = 1;
      } else {
        this.mandatoryShow = 0;
      }
    }
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      if (this.window.width <= 500) {
        this.ismobile = true;
      } else {
        this.ismobile = false;
      }
      this.window.height = window.innerHeight;
    },
    addUnivList(obj) {
      this.univList.push(obj["display"]);
    },
    countup: function() {
      if (this.posterCategoryIdx == 5) {
        this.hasError1 = this.columnContent1.length > this.maxCount;
        this.hasError2 = this.columnContent2.length > this.maxCount;
        this.hasError3 = this.columnContent3.length > this.maxCount;

        this.curCount1 = this.columnContent1.length;
        this.curCount2 = this.columnContent2.length;
        this.curCount3 = this.columnContent3.length;
      } else {
        this.hasError1 = this.outline.length > this.maxCount;
        this.hasError2 = this.target.length > this.maxCount;
        this.hasError3 = this.benefit.length > this.maxCount;
        this.hasError4 = this.period.length > this.maxCount;

        this.curCount1 = this.outline.length;
        this.curCount2 = this.target.length;
        this.curCount3 = this.benefit.length;
        this.curCount4 = this.period.length;
      }
    },
    upload() {
      if (!this.croppa.hasImage()) {
        alert("사진을 등록해주세요");
        return;
      }

      this.croppa.generateBlob(blob => {
        var fd = new FormData();
        fd.append("imgFile", blob, "filename.jpg");

        this.$http
          .post(`/api/posters/reg/photo1`, fd)
          .then(response => {
            if (response.data.status == 200) {
              console.log(response.data.data);
              this.photoUrl = response.data.data.photoUrl.original;
              this.thumbPhotoUrl = response.data.data.photoUrl.thumbnail;
              alert("사진 업로드 완료");
            } else {
              console.log(response);
            }
          })
          .catch(error => {
            console.log(error);
          });
      });

      this.reUpload = false;
    },
    upload2() {
      if (this.file == null) {
        alert("사진을 등록해주세요");
        return;
      }

      var fd = new FormData();
      fd.append("imgFile", this.file, "filename.jpg");

      this.$http
        .post(`/api/posters/reg/photo2`, fd)
        .then(response => {
          if (response.data.status == 200) {
            console.log(response.data.data);
            this.photoUrl2 = response.data.data.photoUrl.original;
            alert("상세이미지 업로드 완료!");
          } else {
            console.log(response);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    uploadInit() {
      this.photoUrl = "";
      this.croppa.remove();
    },
    uploadInit2() {
      this.photoUrl2 = "";
      // const input = this.$refs.file
      // input.type = 'text'
      // input.type = 'file'
      this.file = null;
    },
    // handleFileUpload() {
    //     this.file = this.$refs.file.files[0]
    // },
    clickSub(subIdx) {
      if (subIdx != this.posterSubCategoryIdx) {
        if (subIdx == 0) {
          this.univList = [];
        } else if (subIdx == 1) {
          for (var i = 0; i < this.interestList.length; i++) {
            if (this.interestList[i] >= 900 && this.interestList[i] <= 918) {
              this.interestList.splice(i, 1);
              i--;
            }
          }
        }
        this.posterSubCategoryIdx = subIdx;
        this.isOnlyUniv = subIdx;
      }
    },

    clickInterest(interestIdx) {
      const targetIdx = this.interestList.indexOf(interestIdx);
      let interestName = null;

      if (targetIdx != -1) {
        this.interestList.splice(targetIdx, 1);
        if (interestName != null) {
          let delIdx = this.keywordList.indexOf(interestName);
          if (delIdx != -1) this.keywordList.splice(delIdx, 1);
        }
      } else {
        if (interestIdx == 900) {
          console.log(this.interestList);
          for (var i = 0; i < this.interestList.length; i++) {
            if (this.interestList[i] >= 901 && this.interestList[i] <= 918) {
              console.log(this.interestList);
              this.interestList.splice(i, 1);
              i--;
            }
          }
        } else if (interestIdx >= 901 && interestIdx <= 918) {
          let deleteIdx = this.interestList.indexOf(900);
          if (deleteIdx != -1) {
            this.interestList.splice(deleteIdx, 1);
          }
        }

        if (this.posterCategoryIdx == 4 || this.posterCategoryIdx == 9) {
          //인턴십
          const interestIdxList = [
            101,
            102,
            103,
            104,
            106,
            107,
            109,
            110,
            111,
            112,
            199
          ];

          if (interestIdxList.indexOf(interestIdx) != -1) {
            interestIdxList.forEach(interestId => {
              let deleteIdx = this.interestList.indexOf(interestId);
              if (deleteIdx != -1) {
                this.interestList.splice(deleteIdx, 1);
              }
            });
          }
        } else if (this.posterCategoryIdx == 7) {
          //교육/강연
          const interestIdxList = [601, 602, 603, 604, 699];

          if (interestIdxList.indexOf(interestIdx) != -1) {
            interestIdxList.forEach(interestId => {
              let deleteIdx = this.interestList.indexOf(interestId);
              if (deleteIdx != -1) {
                this.interestList.splice(deleteIdx, 1);
              }
            });
          }
        } else if (this.posterCategoryIdx == 5) {
          //기타
        }

        this.interestList.push(interestIdx);
        if (interestName != null) {
          this.keywordList.push(interestName);
        }
      }
    },
    updatePoster() {
      var isValidInterest = false;

      if (this.posterCategoryIdx == 0) {
        const interestIdxList = [201, 202, 206, 205, 207, 204, 208, 215, 299];

        const filterList = interestIdxList.filter(it =>
          this.interestList.includes(it)
        );

        isValidInterest = filterList.length > 0;
      } else if (this.posterCategoryIdx == 1) {
        const interestIdxList = [
          201,
          202,
          206,
          205,
          207,
          213,
          217,
          253,
          218,
          999
        ];

        const filterList = interestIdxList.filter(it =>
          this.interestList.includes(it)
        );

        isValidInterest = filterList.length > 0;
      } else if (this.posterCategoryIdx == 4 || this.posterCategoryIdx == 9) {
        const interestIdxList = [
          101,
          102,
          103,
          104,
          106,
          107,
          109,
          110,
          111,
          112,
          199
        ];

        const filterList = interestIdxList.filter(it =>
          this.interestList.includes(it)
        );

        isValidInterest = filterList.length > 0;
      } else if (this.posterCategoryIdx == 7) {
        const interestIdxList = [601, 602, 603, 604, 699];

        const filterList = interestIdxList.filter(it =>
          this.interestList.includes(it)
        );

        isValidInterest = filterList.length > 0;
      } else isValidInterest = true;

      if (isValidInterest == false) {
        alert("카테고리 or 관심직무를 선택해주세요");
      } else if (this.photoUrl.trim() == "") {
        alert("사진을 등록해주세요");
      } else if (this.posterName.trim() == "") {
        alert("포스터 제목을 입력해주세요");
      } else if (
        (this.posterCategoryIdx == 4 || this.posterCategoryIdx == 9) &&
        this.companyName.trim() == ""
      ) {
        alert("회사명을 입력해주세요");
      } else if (
        (this.posterCategoryIdx == 4 || this.posterCategoryIdx == 9) &&
        this.regionName.trim() == ""
      ) {
        alert("지역을 입력해주세요");
      } else if (this.publicOpenStartDate.trim() == "") {
        alert("희망 홍보시작일을 입력해주세요");
      } else if (this.publicOpenEndDate.trim() == "") {
        alert("희망 홍보마감일을 입력해주세요");
      } else if (this.posterEndDate.trim() == "") {
        alert("모집시간 마감일을 입력해주세요");
      } else if (this.posterDetail.trim() == "") {
        alert("포스터 자세히보기 내용을 입력해주세요");
      } else {
        if (this.isOnlyUniv == 0) {
          if (this.interestList.indexOf(900) == -1) {
            this.isOnlyUniv = 2;
          }
        }

        console.log(this.interestList);

        this.$http
          .put("/api/posters/" + this.posterIdx, {
            headers: { "Content-type": "application/x-www-form-urlencoded" },
            posterCategoryIdx: this.posterCategoryIdx,
            posterSubCategoryIdx: this.posterSubCategoryIdx,
            hostIdx: this.hostIdx,
            hostName: this.hostName,
            chargerName: this.chargerName,
            partnerPhone: this.partnerPhone,
            partnerEmail: this.partnerEmail,
            interestList: this.interestList,
            photoUrl: this.photoUrl,
            thumbPhotoUrl: this.thumbPhotoUrl,
            photoUrl2: this.photoUrl2,
            posterName: this.posterName,
            publicOpenStartDate: this.publicOpenStartDate,
            publicOpenEndDate: this.publicOpenEndDate,
            posterStartDate: this.posterStartDate,
            posterEndDate: this.posterEndDate,
            documentDate: this.documentDate,
            outline: this.outline,
            target: this.target,
            benefit: this.benefit,
            period: this.period,
            posterDetail: this.posterDetail,
            posterWebsite: this.posterWebsite,
            posterWebsite2: this.posterWebsite2,
            isOnlyUniv: this.isOnlyUniv,
            univList: this.univList,
            isOnlyMajor: this.isOnlyMajor,
            majorList: this.majorList,
            keyword: this.keyword,
            columnName1: this.columnName1,
            columnContent1: this.columnContent1,
            columnName2: this.columnName2,
            columnContent2: this.columnContent2,
            columnName3: this.columnName3,
            columnContent3: this.columnContent3,
            mandatoryShow: this.mandatoryShow,
            adminAccept: this.adminAccept,

            regionName: this.regionName,
            companyName: this.companyName
          })
          .then(response => {
            if (response.data.status == 200) {
              alert("포스터 수정 완료");
              //window.location.href = '/posters/' + this.posterIdx
              this.goback();
            } else {
              alert("승인된 포스터 수정 실패. 관리자에게 문의바랍니다.");
            }
          })
          .catch(error => {
            console.log("register failed", error);
          });
      }
    },

    deletePoster() {
      this.$http
        .delete("/api/posters/" + this.posterIdx)
        .then(response => {
          if (response.data.status == 200) {
            this.goback();
            // var referrer =  document.referrer
            // window.location.href=referrer
            // if(referrer.indexOf(`/posters/${this.posterIdx}`) != -1){
            //     window.location.href='/admin/posters'
            // }else{
            //     window.location.href=referrer
            // }
          } else {
            alert("포스터 삭제 실패");
          }
        })
        .catch(error => {
          console.log("failed", error);
        });
    },

    deleteUniv(index) {
      this.univList.splice(index, 1);
    },
    clickIsOnlyUniv(only) {
      if (this.isOnlyUniv != only) {
        this.isOnlyUniv = only;
        this.univList = [];
        for (var i = 0; i < this.interestList.length; i++) {
          if (
            this.interestList[i].interestIdx >= 900 &&
            this.interestList[i].interestIdx <= 918
          ) {
            this.interestList.splice(i, 1);
            i--;
          }
        }
        if (only == 0) {
          this.interestList.push(900);
        }
      }
    },
    clickIsOnlyMajor(only) {
      if (this.isOnlyMajor != only) {
        this.isOnlyMajor = only;
        for (var i = 0; i < this.majorList.length; i++) {
          for (var j = 0; j < this.majorList[i].selected.length; j++) {
            this.$set(this.majorList[i].selected, j, 0);
          }
          this.majorCategorySelected.splice(i, 1, 0);
        }
      }
    },
    clickMajorCategory1(idx) {
      if (this.majorCategorySelected[idx] == 0) {
        this.majorCategorySelected.splice(idx, 1, 1);

        for (var i = 0; i < this.majorList[idx].selected.length; i++) {
          this.$set(this.majorList[idx].selected, i, 1);
        }
      } else {
        this.majorCategorySelected.splice(idx, 1, 0);
        for (var i = 0; i < this.majorList[idx].selected.length; i++) {
          this.$set(this.majorList[idx].selected, i, 0);
        }
      }
    },
    clickMajorCategory2(idx, idx2) {
      if (this.majorList[idx].selected[idx2] == 0) {
        this.$set(this.majorList[idx].selected, idx2, 1);
      } else {
        this.$set(this.majorList[idx].selected, idx2, 0);
      }
      let tmp = this.majorCategorySelected[idx];
      this.majorCategorySelected.splice(idx, tmp, tmp);
    },
    goback() {
      //var referrer = document.referrer
      //window.location.href = referrer
      this.$router.go(-1);

      // if(referrer.indexOf(`/posters/${this.posterIdx}`) != -1){
      //     window.location.href='/posters'
      // }else{
      //     window.location.href=referrer
      // }
    },
    adminAcceptPoster(adminType) {
      this.$http
        .post(
          "/api/posters/adminAccept/" +
            this.posterIdx +
            "?adminType=" +
            adminType
        )
        .then(response => {
          if (response.data.status == 204) {
            this.goback();
            //window.location.reload()
            //window.location.href='/posters/' + this.posterIdx
          } else {
            alert("로그아웃 되었습니다. 다시 로그인해주세요.");
            this.$store.dispatch("postLogout");
          }
        })
        .catch(error => {
          console.log("failed", error);
        });
    }
  }
};
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/pages/PosterDetail.vue